import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const BENEFITS = ['Entender por qué se repiten ciertos patrones en tu vida y en tu familia', 'Identificar el origen emocional de síntomas físicos concretos', 'Tener un mapa claro de tu historia biológica y emocional', 'Aplicar la biodecodificación en vos y en las personas que acompañás', 'Avanzar a tu propio ritmo, desde donde estés, con material profesional'];
export function BenefitsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-17">
      <div className="container mx-auto max-w-3xl" data-id="element-18">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#eab308] mb-10 text-center" data-id="element-20">
            ¿Qué vas a lograr?
          </h2>

          <div className="space-y-4" data-id="element-21">
            {BENEFITS.map((benefit, idx) => <div key={idx} className="flex items-start gap-4 bg-[#111111] p-5 rounded-xl border border-white/10" data-id="element-22">
                <div className="bg-[#eab308]/20 p-2 rounded-full flex-shrink-0 mt-0.5" data-id="element-23">
                  <CheckIcon className="w-5 h-5 text-[#eab308]" strokeWidth={3} data-id="element-24" />
                </div>
                <span className="text-gray-200 text-lg leading-relaxed" data-id="element-25">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}